import styled from 'styled-components'
import {Paragraph} from '@modifi/ui'

export const StyledParagraph = styled(Paragraph)`
  ${({textAlign}: {textAlign?: string}): string | null =>
    textAlign ? `text-align: ${textAlign}` : null};
`
